import '../../css/progress.css';

import { LocalizationService } from '../services/localization-service';
import { Dialog, IDialogButton } from "../components/modals/Dialog/dialog";
import { DataLayerService } from '../services/data-layer-service';
import { DataLayerErrorType } from '../types/enums';

export class DialogCreators {
    /**
     * Displays a message box with a single OK button.
     * Extra parameters (localizationService, buttonHoverStyle, focusElementID, errorId) are kept for compatibility.
     *
     * @param localizationService - (Unused) Localization service.
     * @param dataLayerService - (Optional) Data layer service for logging errors.
     * @param message - The message to display (string or HTMLElement).
     * @param isUserErrorMsg - Indicates if the message is a user error message (default is false).
     * @param callBack - Optional callback to execute when the OK button is clicked.
     */
    public static messageBoxOk(
        localizationService: LocalizationService,
        dataLayerService: DataLayerService | null,
        message: string,
        isUserErrorMsg: boolean = false,
        callBack?: Function | null,
    ): void {
        const okButton: IDialogButton = {
            label: localizationService.names("Ok"),
            value: "ok",
            action: () => {
                if (callBack) callBack();
            }
        };

        new Dialog(message, [okButton]);

        if (isUserErrorMsg && dataLayerService) {
            dataLayerService.error_message(message, DataLayerErrorType.USER_ERROR);
        }
    }

    /**
     * Displays a message box with multiple buttons.
     * Extra parameters (localizationService and buttonHoverStyle) are kept for compatibility.
     *
     * @param message - The message to display.
     * @param buttons - An array of button definitions, each with text and an optional callback.
     * @returns Returns a string (for backward compatibility, returns an empty string).
     */
    public static messageBox(
        message: string,
        buttons: { text: string, callBack: Function | null }[]
    ): string {
        const mappedButtons: IDialogButton[] = buttons.map((btn, index) => ({
            label: btn.text,
            value: `btn_${index}`,
            action: () => {
                if (btn.callBack) btn.callBack();
            }
        }));

        new Dialog(message, mappedButtons);
        return "";
    }
}